import { SEARCH_SUGGESTIONS_REQUEST } from './searchActions';
export const INCREMENT_COUNTER = 'INCREMENT_COUNTER';
export const DECREMENT_COUNTER = 'DECREMENT_COUNTER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const ADD_TO_CART = 'ADD_TO_CART';
export const FAIL_ADD_TO_CART = 'FAIL_ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
export const GET_CART_FAIL = 'GET_CART_FAIL';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAIL = 'GET_PRODUCT_FAIL';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAIL = 'GET_ALL_USERS_FAIL';
export const GET_ADMIN_PRODUCT_SUCCESS = 'GET_ADMIN_PRODUCT_SUCCESS';
export const GET_ADMIN_PRODUCT_FAILURE = 'GET_ADMIN_PRODUCT_FAILURE';
export const ADD_PRODUCT_FAIL = 'ADD_PRODUCT_FAIL';
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';
export const FETCH_PRODUCT_BY_ID = 'FETCH_PRODUCT_BY_ID';
export const FAIL_FETCH_PRODUCT_BY_ID = 'FAIL_FETCH_PRODUCT_BY_ID';
export const CLEAR_OLD_FETCH_SUCCESS = 'CLEAR_OLD_FETCH_SUCCESS';
export const CLEAR_OLD_FETCH_FAIL = 'CLEAR_OLD_FETCH_FAIL';
export const GET_FACILITY_SUCCESS = 'GET_FACILITY_SUCCESS';
export const GET_FACILITY_FAILED = 'GET_FACILITY_FAILED';
export const CREATE_FACILITY_SUCCESS = 'CREATE_FACILITY_SUCCESS';
export const CREATE_FACILITY_FAILED = 'CREATE_FACILITY_FAILED';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILED = 'GET_CATEGORIES_FAILED';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_FAILED = 'CREATE_CATEGORY_FAILED';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILED = 'UPDATE_CATEGORY_FAILED';
export const GET_ALL_FACILITY_SUCCESS = 'GET_ALL_FACILITY_SUCCESS';
export const GET_ALL_FACILITY_FAILED = 'GET_ALL_FACILITY_FAILED';
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_FAILED = 'ORDER_FAILED';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_FAILED = 'GET_ORDER_FAILED';
export const GET_ADMIN_ORDER_SUCCESS = 'GET_ADMIN_ORDER_SUCCESS';
export const GET_ADMIN_ORDER_FAILURE = 'GET_ADMIN_ORDER_FAILURE';
export const GET_ADMIN_ORDER_REQUEST = 'GET_ADMIN_ORDER_REQUEST';
export const GET_ONE_ORDER_SUCCESS = 'GET_ONE_ORDER_SUCCESS';
export const GET_ONE_ORDER_FAILURE = 'GET_ONE_ORDER_FAILURE';
export const CLEAR_SEARCH_SUGGESTIONS = 'CLEAR_SEARCH_SUGGESTIONS';
export const SEARCH_SUGGESTIONS_REQUEST = 'SEARCH_SUGGESTIONS_REQUEST';
export const SEARCH_SUGGESTIONS_SUCCESS = 'SEARCH_SUGGESTIONS_SUCCESS';
export const SEARCH_SUGGESTIONS_FAIL = 'SEARCH_SUGGESTIONS_FAIL';
export const UPDATE_ORDER_STATUS_SUCCESS = 'UPDATE_ORDER_STATUS_SUCCESS';
export const UPDATE_ORDER_STATUS_FAILURE = 'UPDATE_ORDER_STATUS_FAILURE';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILED = 'DELETE_CATEGORY_FAILED';

export const UPDATE_FACILITY_FAILED = 'UPDATE_FACILITY_FAILED';
export const UPDATE_FACILITY_SUCCESS = 'UPDATE_FACILITY_SUCCESS';

export const GET_SALES_REPORT_REQUEST = 'GET_SALES_REPORT_REQUEST';
export const GET_SALES_REPORT_SUCCESS = 'GET_SALES_REPORT_SUCCESS';
export const GET_SALES_REPORT_FAILED = 'GET_SALES_REPORT_FAILED';
export const GET_TODAY_SALES_REQUEST = 'GET_TODAY_SALES_REQUEST';
export const GET_TODAY_SALES_SUCCESS = 'GET_TODAY_SALES_SUCCESS';
export const GET_TODAY_SALES_FAILURE = 'GET_TODAY_SALES_FAILURE';

export const UPDATE_CART_ITEM_QUANTITY = 'UPDATE_CART_ITEM_QUANTITY';

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const IMPORT_PRODUCTS_SUCCESS = 'IMPORT_PRODUCTS_SUCCESS';
export const IMPORT_PRODUCTS_FAIL = 'IMPORT_PRODUCTS_FAIL';

export const GET_PRICE_GROUPS_SUCCESS = 'GET_PRICE_GROUPS_SUCCESS';
export const GET_PRICE_GROUPS_FAIL = 'GET_PRICE_GROUPS_FAIL';
export const CREATE_PRICE_GROUP_SUCCESS = 'CREATE_PRICE_GROUP_SUCCESS';
export const UPDATE_PRICE_GROUP_SUCCESS = 'UPDATE_PRICE_GROUP_SUCCESS';
export const DELETE_PRICE_GROUP_SUCCESS = 'DELETE_PRICE_GROUP_SUCCESS';

